<clr-datagrid *ngIf="!!confirmation" [clrDgLoading]="loading">
  <clr-dg-column [clrDgField]="'project_id'">Auftragsbestätigung</clr-dg-column>
  <clr-dg-column [clrDgField]="'confirmation_date'">Datum</clr-dg-column>
  <clr-dg-column [clrDgField]="'company_name'">Empfänger</clr-dg-column>
  <clr-dg-column [clrDgField]="'order_id'">Bestellnummer des Kunden</clr-dg-column>
  <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
  <clr-dg-column [clrDgField]="'delivery_date'">Lieferdatum</clr-dg-column>
  <clr-dg-placeholder>We couldn't find any Confirmation!</clr-dg-placeholder>
  <clr-dg-row *clrDgItems="let confirmation of confirmation" >
    <clr-dg-cell [routerLink]="['/confirmation/details/', projectID, jobID, confirmation.confirmation_id]">{{ confirmation.project_id }}.0008.{{ confirmation.confirmation_id }}</clr-dg-cell>
    <clr-dg-cell>{{ confirmation.job_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
    <clr-dg-cell>{{ confirmation.company_name }}</clr-dg-cell>
    <clr-dg-cell>{{ confirmation.order_id }}</clr-dg-cell>
    <clr-dg-cell><b>{{ confirmation.name_project }}</b></clr-dg-cell>
    <clr-dg-cell>{{ confirmation.delivery_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
  </clr-dg-row>
  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="50">
      <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
      von {{confirmation.length}} Job(s)
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>
